"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMING_COMPONENT_CATALOG = void 0;
exports.findNamingComponentDefinition = findNamingComponentDefinition;
const naming_convention_format_1 = require("./naming-convention-format");
const CAMPAIGN_COMPONENTS = [
    {
        key: 'funnelStage',
        label: 'Campaign',
        hint: 'The funnel stage this campaign serves.',
        suggestions: ['Prospecting', 'Retargeting', 'Retention', 'TOFU', 'MOFU', 'BOFU'],
    },
    {
        key: 'campaignGoal',
        label: 'Campaign Goal',
        hint: "The campaign's objective on the platform.",
        suggestions: ['Awareness', 'Traffic', 'Engagement', 'Leads', 'Sales', 'App Promotion'],
    },
    {
        key: 'campaignType',
        label: 'Campaign Type',
        hint: 'What this campaign is for — proving a new idea, or scaling a proven one.',
        suggestions: ['Testing', 'Scaling', 'Evergreen', 'Launch', 'Seasonal', 'Promo'],
    },
    {
        key: 'bidStrategy',
        label: 'Bid Strategy',
        hint: "The campaign's bid approach.",
        suggestions: ['Max Volume', 'Highest Volume', 'Cost Cap', 'Bid Cap', 'tROAS', 'Manual'],
    },
    {
        key: 'uniqueIdentifier',
        label: 'Unique Identifier',
        hint: 'A short marker that tells this campaign apart from its siblings.',
        suggestions: ['Always On', 'Q1', 'Q2', 'Q3', 'Q4', 'BFCM', 'V1', 'V2'],
    },
    {
        key: 'budgetOptimization',
        label: 'Budget Optimization',
        hint: 'CBO when the budget sits on the campaign, ABO when it sits on each ad set.',
        suggestions: ['CBO', 'ABO'],
    },
];
const AD_SET_COMPONENTS = [
    {
        key: 'groupingBatch',
        label: 'Grouping Batch',
        hint: 'What the ad sets inside this campaign are grouped by.',
        suggestions: ['Ad Angle', 'Ad Concept', 'Audience', 'Creator', 'Product', 'Batch 1', 'Batch 2'],
    },
    {
        key: 'targeting',
        label: 'Targeting',
        hint: 'How the audience is defined.',
        suggestions: ['Open', 'Broad', 'Interest', 'LAL', 'Custom Audience', 'Retargeting', 'Advantage+'],
    },
    {
        key: 'age',
        label: 'Age',
        hint: 'The age range this ad set targets.',
        suggestions: ['18+', '25+', '18-24', '25-34', '35-44', '45-54', '55-65', '18-65'],
    },
    {
        key: 'gender',
        label: 'Gender',
        hint: 'The gender this ad set targets.',
        suggestions: ['all Genders', 'Men', 'Women'],
    },
    {
        key: 'region',
        label: 'Region',
        hint: 'The geography or market grouping.',
        suggestions: ['Worldwide', 'US', 'UK', 'Germany', 'DACH', 'EU', 'EMEA', 'APAC', 'LATAM'],
    },
    {
        key: 'placement',
        label: 'Placement',
        hint: 'Where the ads run.',
        suggestions: [
            'allPlacements',
            'Advantage+',
            'Feed',
            'Stories',
            'Reels',
            'Feed Square',
            'In-Stream Video',
            'Landscape',
        ],
    },
    {
        key: 'optimizationEvent',
        label: 'Optimization Event',
        hint: 'The conversion event this ad set optimizes for.',
        suggestions: [
            'Purchase',
            'Add to Cart',
            'Initiate Checkout',
            'Lead',
            'Complete Registration',
            'Landing Page View',
            'Link Clicks',
            'Reach',
        ],
    },
];
const AD_COMPONENTS = [
    {
        key: 'date',
        label: 'Date',
        hint: 'The launch date, written in the format you pick here.',
        suggestions: naming_convention_format_1.DATE_TOKENS,
        kind: 'DATE',
    },
    {
        key: 'product',
        label: 'Product / Service',
        hint: 'What the ad advertises.',
        suggestions: [],
    },
    {
        key: 'adFormat',
        label: 'Ad Format',
        hint: "The creative's format.",
        suggestions: ['Static', 'Video', 'Carousel', 'Collection', 'Catalogue', 'GIF'],
    },
    {
        key: 'adConcept',
        label: 'Ad Concept',
        hint: 'The creative approach the ad takes.',
        suggestions: [
            'Founder Ad',
            'Testimonial',
            'Us vs Them',
            'UGC',
            'Unboxing',
            'Before After',
            'Listicle',
            'Problem Solution',
            'Demo',
        ],
    },
    {
        key: 'creator',
        label: 'Creator / Agency',
        hint: 'Who made the creative — a UGC creator, an agency, or in-house.',
        suggestions: ['In-House', 'Agency', 'AI'],
    },
    {
        key: 'adAngle',
        label: 'Ad Angle',
        hint: 'The core message or hook the ad leads with.',
        suggestions: ['Price', 'Quality', 'Convenience', 'Social Proof', 'Urgency', 'Ingredients', 'Sustainability'],
    },
    {
        key: 'uniqueIdentifier',
        label: 'Unique Identifier',
        hint: 'A short marker that tells this ad apart from its variants.',
        suggestions: ['Always On', 'V1', 'V2', 'V3', 'Hook A', 'Hook B'],
    },
    {
        key: 'landingPage',
        label: 'Landing Page',
        hint: 'Where the ad sends people.',
        suggestions: ['Home', 'PDP', 'Collection', 'Quiz', 'Advertorial', 'Landing Page'],
    },
];
/**
 * Every component the UI offers, per level.
 *
 * The ad-set "Optimization Event" and the ad-level "Unique Identifier" / "Landing Page" rows sit
 * below the fold in the source design; their labels follow the field names the default convention
 * (`AD_NAMING_LEVELS` in the API) already uses at those positions.
 */
exports.NAMING_COMPONENT_CATALOG = {
    campaign: CAMPAIGN_COMPONENTS,
    adSet: AD_SET_COMPONENTS,
    ad: AD_COMPONENTS,
};
/** Looks up a component definition, or `undefined` when the key is not in the catalog. */
function findNamingComponentDefinition(level, key) {
    return exports.NAMING_COMPONENT_CATALOG[level].find((component) => component.key === key);
}
